<template>
  <div v-if="mostrarContenedor && itemsSeleccionados.length > 0">
    <table
      class="tg"
      v-for="item in itemsSeleccionados"
      :key="item.id"
      :style="{
        'page-break-before': 'always',
        'top': top,
        'left': left,
        'width': width
      }"
    >
      <slot name="colgroup">
        <colgroup>
          <col style="width: 85px" />
          <col style="width: 80px" />
          <col style="width: 50px" />
          <col style="width: 300px" />
          <col style="width: 160px" />
        </colgroup>
      </slot>
      <tr>
        <th
          :colspan="cols"
          class="sin-borde"
        >
          <imprimir-cabecera>
            <slot
              name="cabecera"
              v-bind="item"
            ></slot>
          </imprimir-cabecera>
        </th>
      </tr>
      <slot
        name="contenido"
        v-bind="item"
      ></slot>
    </table>
  </div>
</template>

<script>
import ImprimirCabecera from './ImprimirCabecera'
export default {
  props: {
    width: {
      type: String,
      default: '612px'
    },
    top: {
      type: String,
      default: '40px'
    },
    left: {
      type: String,
      default: '40px'
    },
    item: {
      type: Object,
      default () {
        return null
      }
    },
    items: {
      type: Array,
      default () {
        return []
      }
    },
    mostrar: {
      type: Boolean,
      default: false
    },
    cols: {
      type: Number,
      default: 5
    }
  },
  components: {
    ImprimirCabecera
  },
  data () {
    return {
      itemsSeleccionados: this.item ? [this.item] : this.items,
      mostrarContenedor: this.mostrar
    }
  },
  watch: {
    mostrar: function (value) {
      this.mostrarContenedor = value
    },
    item: function (value) {
      this.$set(this.itemsSeleccionados, 0, value)
    },
    items: {
      handler: function (value) {
        this.itemsSeleccionados = value
      },
      deep: true
    }
  }
}
</script>

<style lang="scss" scoped>
.tg {
  border-collapse: collapse;
  border-spacing: 0;
}
.tg td {
  font-family: Arial, sans-serif;
  font-size: 13px;
  padding: 7px 5px;
  border-style: solid;
  border-width: 1px;
  overflow: hidden;
  word-break: normal;
  border-color: black;
}
.tg th {
  font-family: Arial, sans-serif;
  font-size: 12px;
  font-weight: normal;
  padding: 5px 5px;
  border-style: solid;
  border-width: 1px;
  overflow: hidden;
  word-break: normal;
  border-color: black;
}
.tg .tg-bzci {
  font-size: 16px;
  text-align: center;
  vertical-align: top;
}
.tg .tg-jzjz {
  font-family: Verdana, Geneva, sans-serif !important;
  text-align: center;
  vertical-align: top;
}
.tg .tg-jzjzleft {
  font-family: Verdana, Geneva, sans-serif !important;
  text-align: left;
  vertical-align: top;
}
.sin-borde {
  border-top: none !important;
  border-bottom: none !important;
  border-left: none !important;
  border-right: none !important;
}
.sin-borde-lateral {
  border-left: none !important;
  border-right: none !important;
}

.tg .tg-desc {
  font-family: Verdana, Geneva, sans-serif !important;
  text-align: left;
  vertical-align: top;
  border-top: none !important;
  border-bottom: none !important;
  font-size: 15px;
  padding-top: 20px;
  padding-bottom: 20px;
  line-height: 25px;
}
.tg .tg-0lax {
  text-align: left;
  vertical-align: top;
}
.txt-right {
  text-align: right !important;
}

.tg .tg-9apd {
  font-size: 14px;
  background-color: #c0c0c0;
  text-align: center;
  vertical-align: top;
}
.tg-key {
  font-weight: 700;
}
.tg-espacio {
  border-left: none !important;
  border-right: none !important;
}
.txt-center {
  text-align: center !important;
}
.firma {
  display: inline-block;
}
.item-firma {
  width: 30%;
  display: inline-block;
  margin-bottom: 90px;
}
.borde-top {
  border-left: none !important;
  border-right: none !important;
  border-bottom: 1px solid !important;
  border-bottom: none !important;
}
table:not(:last-child) .tg-separador {
  border-bottom: 1px solid !important;
  border-left: none !important;
  border-right: none !important;
  border-top: none !important;
  height: 100px !important;
}
table:last-child .tg-separador {
  border-bottom: none !important;
  border-left: none !important;
  border-right: none !important;
  border-top: none !important;
  height: 1px !important;
}
@media print {
  .no-print,
  .no-print * {
    display: none !important;
  }
}
</style>
